import type { DashboardRevenueProjectionMethodDto, ProductionHistoryHorizonDto } from '../query';
import { GetDetailsResponse } from './common';

export const PRODUCTION_HISTORY_PREMIUM_SOURCES = {
  Actual: 'actual',
  Projected: 'projected',
  Mixed: 'mixed',
} as const;

export type ProductionHistoryPremiumSource =
  (typeof PRODUCTION_HISTORY_PREMIUM_SOURCES)[keyof typeof PRODUCTION_HISTORY_PREMIUM_SOURCES];

export type ProductionHistoryProjectionFields = {
  actualPremium?: number;
  projectedPremium?: number | null;
  isProjected?: boolean;
  premiumSource?: ProductionHistoryPremiumSource;
  projectionMethod?: DashboardRevenueProjectionMethodDto | null;
  projectionAsOfDate?: string | null;
};

export type ProductionHistoryResponseMeta = {
  horizon?: ProductionHistoryHorizonDto;
  method?: DashboardRevenueProjectionMethodDto | null;
  /** Trusted paid-through date after reporting lag (estimation cutoff). */
  projectionAsOfDate?: string | null;
  /** Last week projection math trusts (data boundary minus lagWeeks). */
  asOfWeek?: number;
  /** Last complete week actually covered by the paid file. */
  dataWeek?: number;
  /** Reporting lag in weeks; same default as Revenue Analytics (3). */
  lagWeeks?: number;
};

export type ProductionHistoryMonthlyItemResponse = ProductionHistoryProjectionFields & {
  year: number;
  month: number;
  premium: number;
  changeOverMonth: number | null;
  changeOverYear: number | null;
  avgPerYear: number;
  monthRankInYear: number;
  isProjectionDerived?: boolean;
  changeOverMonthIsProjectionDerived?: boolean;
  changeOverYearIsProjectionDerived?: boolean;
};

export type ProductionHistoryQuarterlyItemResponse = ProductionHistoryProjectionFields & {
  year: number;
  quarter: number;
  premium: number;
  changeOverQuarter: number | null;
  changeOverYear: number | null;
  quarterRankInYear: number;
  isProjectionDerived?: boolean;
  changeOverQuarterIsProjectionDerived?: boolean;
  changeOverYearIsProjectionDerived?: boolean;
};

export type ProductionHistoryYearlyItemResponse = ProductionHistoryProjectionFields & {
  year: number;
  maxTransdate: string;
  premium: number;
  rank: number;
  changeOverYear: number | null;
  isProjectionDerived?: boolean;
  changeOverYearIsProjectionDerived?: boolean;
};

export type ProductionHistoryMonthlyResponse = GetDetailsResponse<ProductionHistoryMonthlyItemResponse[]> &
  ProductionHistoryResponseMeta;

export type ProductionHistoryQuarterlyResponse = GetDetailsResponse<ProductionHistoryQuarterlyItemResponse[]> &
  ProductionHistoryResponseMeta;

export type ProductionHistoryYearlyResponse = GetDetailsResponse<ProductionHistoryYearlyItemResponse[]> &
  ProductionHistoryResponseMeta;
